import React from 'react';
import styled from 'styled-components';

interface ConversionBannerTextProps {
  isFixedMatches: boolean;
  message: string;
}

const ConversionBannerTextContainer = styled.div`
  white-space: normal;
  margin-bottom: 1rem;

  @media screen and (min-width: 30em) {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media screen and (min-width: 30em) and (max-width: 60em) {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  @media screen and (min-width: 60em) {
    margin-bottom: 0;
  }
`;

const ConversionBannerText: React.FC<ConversionBannerTextProps> = ({ isFixedMatches, message }) => {
  if (isFixedMatches) {
    return null;
  }

  return <ConversionBannerTextContainer>{message}</ConversionBannerTextContainer>;
};

export default ConversionBannerText;
